import { ComponentProps } from 'react';

export function Lightbulb({ ...props }: ComponentProps<'svg'>) {
  return (
    <svg
      {...props}
      width="22"
      height="32"
      viewBox="0 0 22 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.00625 28.3937C6.00625 28.7873 6.11975 29.1712 6.3365 29.4994L7.40775 31.105C7.73588 31.5972 8.48088 31.9975 9.07275 31.9975H12.9271C13.517 31.9975 14.2621 31.5974 14.5903 31.105L15.6577 29.5C15.8414 29.2226 15.992 28.7269 15.992 28.3937L16 25.9438H6L6.00625 28.3937ZM11 0C4.62625 0.0200188 0 5.18563 0 10.9438C0 13.7175 1.0275 16.2463 2.7225 18.1812C3.75563 19.3587 5.36875 21.8206 5.98625 23.8969C5.98821 23.9125 5.99211 23.9292 5.99406 23.9458H16.0066C16.0085 23.9292 16.0124 23.9135 16.0144 23.8969C16.6316 21.8206 18.245 19.3587 19.2781 18.1812C20.975 16.3 22 13.775 22 10.9438C22 4.925 17.075 0.00024375 11 0ZM17.025 16.2563C16.0462 17.3719 14.835 19.15 13.9594 20.9994H8.04625C7.17063 19.15 5.95937 17.3719 4.98125 16.2569C3.7025 14.8 3 12.8813 3 10.9438C3 7.08125 6.00625 3.01562 10.9438 3C15.4125 3 19 6.5875 19 10.9438C19 12.8813 18.3 14.8 17.025 16.2563ZM10 5C7.24375 5 5 7.24375 5 10C5 10.5527 5.44725 11 6 11C6.55275 11 7 10.55 7 10C7 8.34562 8.34562 7 10 7C10.5527 7 11 6.55325 11 6.00063C11 5.448 10.55 5 10 5Z"
        fill="currentColor"
      />
    </svg>
  );
}
